import axios from 'axios'
import {
  EnterpriseModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseLocation,
  LocationModel,
  ResponseObjectURL,
  TableResumen,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getEnterprise(dto: EnterpriseModel, page: number) {
  return axios.post<ResponseObjectPaginated<EnterpriseModel[]>>(
    `${BASEURL}/enterprise/getAll/${page}`,
    dto,
  )
}

export function getEnterpriseBySearch(dto: EnterpriseModel, page: number = 1, size: number = 99) {
  return axios.post<ResponseObjectPaginated<EnterpriseModel[]>>(
    `${BASEURL}/enterprise/SearchOptions`,
    dto,
    {
      params: {
        page: page,
        size: size,
      }
    }
  )
}

export function getCountry() {
  return axios.get<ResponseLocation<LocationModel[]>>(`${BASEURL}/ubigee/getCountries`)
}

export function getEnterpriseById(dto: string | undefined) {
  return axios.get<ResponseObject<EnterpriseModel>>(
    `${BASEURL}/enterprise/getInformationById?enterpriseId=${dto}`,
  )
}

export function createEnterprise(dto: EnterpriseModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/enterprise/createEnterprise`, dto)
}

export function deleteEnterprise(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/enterprise/deleteEnterprise?id=${dto}`)
}

export function updateEnterprise(dto: EnterpriseModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/enterprise/updateEnterprise`, dto)
}

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateEnterprise() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/enterprise/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveEnterprise(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/enterprise/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE
